module.exports = __webpack_public_path__ + "static/media/B3FF9C19-DD28-43C6-A0D7-1B21E3C4A151.2ca5c762.JPG";